import { createSelector } from "reselect";

export const getAllExpenseCategories = createSelector(
  (state) => state.expense_categories,
  (expense_categories) => expense_categories
);

export const getAllExpenseCategoriesArray = createSelector(getAllExpenseCategories, (expenseCategories) =>
  Object.values(expenseCategories)
);

export const getExpenseCategoryById = createSelector(
  getAllExpenseCategories,
  (state, id) => id,
  (expenseCategories, id) => expenseCategories[id]
);

export const getActiveExpenseCategoriesArrayOfIdAndName = createSelector(
  getAllExpenseCategoriesArray,
  (expenseCategories) => expenseCategories.filter((e) => !e.is_archived).map((e) => ({ id: e.id, name: e.name }))
);

export const getDefaultExpenseCategoryName = createSelector(getAllExpenseCategoriesArray, (allExpenseCategories) => {
  const defaultExpenseCategory = allExpenseCategories.find((expenseCategory) => expenseCategory.is_default);
  return defaultExpenseCategory ? defaultExpenseCategory.name : ``;
});

const getActiveExpenseCategoryById = createSelector(getExpenseCategoryById, (category) => {
  if (category && Boolean(category.is_archived) === false) {
    return category;
  }
  return null;
});

export const getSelectedCategoryName = createSelector(
  getActiveExpenseCategoryById,
  getDefaultExpenseCategoryName,
  (selected, defaultName) => (selected ? selected.name : defaultName)
);

export const getActiveExpenseCategoriesSortedByName = createSelector(
  getAllExpenseCategoriesArray,
  (expenseCategories) => expenseCategories.filter((e) => !e.is_archived).sort((a, b) => a.name.localeCompare(b.name))
);
